import { CompositionConfig } from '../../types/CompositionConfig';
import { SegmentType } from '../../types/Segment/Type';
import { VideoSegment } from '../../types/Segment/VideoSegment';
import { SegmentsTrack } from '../../types/Track/SegmentsTrack';
import { TrackType } from '../../types/Track/Type';

export const getPlayerConfigIntro = (playerConfig: CompositionConfig | null) => {
  const segmentTracks = playerConfig?.playerConfig.tracks.find(
    track => track.type === TrackType.SEGMENTS
  ) as SegmentsTrack;
  const videoSegments = segmentTracks?.segments.filter(segment => segment.type === SegmentType.VIDEO) as VideoSegment[];

  return videoSegments?.find(segment => segment.id === 'intro');
};

export const getPlayerConfigOutro = (playerConfig: CompositionConfig | null) => {
  const segmentTracks = playerConfig?.playerConfig.tracks.find(
    track => track.type === TrackType.SEGMENTS
  ) as SegmentsTrack;
  const videoSegments = segmentTracks?.segments.filter(segment => segment.type === SegmentType.VIDEO) as VideoSegment[];

  return videoSegments?.find(segment => segment.id === 'outro');
};
